import { CustomText, CustomHeading } from "../../StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';

export function SectionHeader({ ctx, uiState }) {
  const { heading, subtitles = [], pageHeading = false } = ctx || {};
  const { headingSize = "md", fontSize = 18 } = uiState || {};

  return (
    <div
      style={{
        marginBlockEnd: `${pageHeading ? "2rem" : "1rem"}`
      }}>
      <CustomHeading fontSize={fontSize} size={headingSize} margin="0">
        {heading}
      </CustomHeading>

      {subtitles?.length && (
        subtitles.map((subtitle) => (
          <CustomText margin="0 0" size="xs" key={subtitle}>
            {subtitle}
          </CustomText>
        ))
      )}
    </div>
  );
};

SectionHeader.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
}